import type { SVGProps } from 'react';

const SvgAiStar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer_1" viewBox="0 0 30.2 30.2" {...props}>
    <path
      fill={props.color}
      d="M15.1 30.2c-.58 0-1.12-.34-1.36-.87l-3.53-7.56c-.36-.79-1-1.42-1.79-1.79L.86 16.45c-.52-.24-.86-.78-.86-1.36s.34-1.12.87-1.36l7.56-3.53c.79-.37 1.42-1 1.79-1.79L13.74.86a1.506 1.506 0 0 1 2.72 0l3.53 7.56c.37.79 1 1.42 1.79 1.79l7.56 3.53c.52.24.86.78.86 1.36s-.34 1.12-.87 1.36l-7.56 3.53c-.79.37-1.42 1-1.79 1.79l-3.53 7.56c-.24.52-.78.86-1.36.86Zm0-28.7-3.53 7.55a5.15 5.15 0 0 1-2.51 2.51L1.5 15.09l7.56 3.53c1.11.51 2 1.41 2.51 2.51l3.53 7.56 3.53-7.56c.51-1.11 1.41-2 2.51-2.51l7.56-3.53-7.56-3.53a5.15 5.15 0 0 1-2.51-2.51zm0-.01"
    />
  </svg>
);

export default SvgAiStar;
